<template>
    <div>
        <div class="alert alert-danger" v-if="formErrors">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in form.errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>
        <div class="alert alert-info" role="alert" v-show="form.vendor === 'Twitter'">
            <strong>Hold up!</strong> Please be sure to add the Twitter Social Profile before adding this account.
        </div>
        <form class="form-horizontal" role="form" @submit.prevent="addAdAccount">
            <!-- Vendor -->
            <div class="form-group">
                <label class="col-md-4 control-label">Vendor</label>

                <div class="col-md-6">
                    <select class="form-control" name="budget_type" v-model="form.vendor">
                        <option value="">Select</option>
                        <option value="AdWords">AdWords</option>
                        <option value="Bing Ads">Bing Ads</option>
                        <option value="Facebook">Facebook</option>
                        <option value="LinkedIn">LinkedIn</option>
                        <option value="Quora">Quora</option>
                        <option value="Twitter">Twitter</option>
                        <option value="Yahoo!">Yahoo!</option>
                    </select>
                </div>
            </div>

            <!-- Account ID -->
            <div class="form-group">
                <label class="col-md-4 control-label">Account ID</label>

                <div class="col-md-6">
                    <input type="text" class="form-control" name="budget" v-model="form.account_id">
                </div>
            </div>

            <!-- Token ID -->
            <div class="form-group" v-if="['AdWords','Bing Ads'].includes(form.vendor)">
                <label class="col-md-4 control-label">MCC</label>

                <div class="col-md-6">
                    <select class="form-control" name="token_id" v-model="form.token_id">
                        <option value="">Select</option>
                        <option v-for="(item, idx) in mccs[form.vendor]" :key="idx" :value="item.token_id" v-text="item.name"></option>
                    </select>
                </div>
            </div>

            <!-- Account Label -->
            <div class="form-group">
                <label class="col-md-4 control-label">Label</label>

                <div class="col-md-6">
                    <input type="text" class="form-control" name="budget" v-model="form.account_label" placeholder="Optional">
                </div>
            </div>

            <!-- Rollup -->
            <div class="form-group">
                <label class="col-md-4 control-label">Rollup</label>

                <div class="col-md-6">
                    <select class="form-control" name="token_id" v-model="form.rollup">
                        <option :value="null">None</option>
                        <option v-for="(item, idx) in rollups" :key="idx" :value="item" v-text="item"></option>
                    </select>
                </div>
            </div>

            <!-- Add Button -->
            <div class="form-group">
                <div class="col-md-offset-4 col-md-6">
                    <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">
                        Add Account
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            form: {
                client_name: '',
                vendor: '',
                account_id: '',
                errors: '',
                status: 'ENABLED',
                token_id: '',
                account_label: '',
                rollup: null
            },
            loading: false,
            rollups: [],
            mccs: {
                'AdWords': [
                    {token_id: 'adwords', name: 'Found SM'},
                    {token_id: 'adwords-ap', name: 'Edu Lead Gen'},
                    {token_id: 'adwords-as', name: 'Author Solutions - Double Serve'},
                ],
                'Bing Ads': [
                    {token_id: 'bingads-foundsm', name: 'Found SM'},
                    {token_id: 'bingads-ap', name: 'Edu Lead Gen'},
                ]
            }
        }
    },

    computed: {
        ...mapGetters('client', {
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        }),

        formErrors() {
            return Object.keys(this.form.errors).length > 0;
        }
    },

    created() {
        this.getRollups();
    },

    methods: {
        getRollups() {
            axios.get('/api/ad-accounts/rollups').then(({data}) => this.rollups = data);
        },

        addAdAccount() {
            this.loading = true;
            this.form.client_name = this.client.name;
            this.form.token_id = this.getTokenIdForVendor(this.form.vendor);
            let adAccount = this.form;
            this.$store.dispatch('client/addAdAccount', {
                    adAccount: adAccount,
                }).then(response => {
                    Bus.$emit('show-success-alert', response.message);
                    Bus.$emit('ad-account-added');
                    this.reset();
                })
                .catch(response => {
                    if (response.status !== 422) {
                        Bus.$emit('show-error-alert', response.data.message);
                    } else {
                        this.form.errors = response.data.errors;
                    }
                    this.loading = false;
                });
        },

        getTokenIdForVendor(vendor) {
            switch (vendor) {
                case 'Facebook':
                    return 'facebook'
                case 'Yahoo!':
                    return 'yahoo-foundsm'
                case 'LinkedIn':
                    return 'linkedin'
                case 'Quora':
                    return 'quora'
                case 'Twitter':
                    return `twitter-${this.client.slug}`
                default:
                    return this.form.token_id;
            }
        },

        reset() {
            Object.assign(this.$data, this.$options.data());
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/NewAdAccountForm.vue